import { themeOptions } from 'constants/constants';
import themeEuOldUI from 'styles/theme/eu';

export const FindTheme = (code: string) => {
  const theme = themeOptions.find((x) => x.code.toLowerCase() === code.toLowerCase())?.themes;
  return theme?.old ?? themeEuOldUI;
};
